<template>
    <div id="app">
        <div class="container">
            <router-view/>
        </div>
    </div>
</template>

<script>
export default {
  name: 'App',
    data() {
        return {
        };
    },
    create(){
    },
    mounted(){
        this.init();
    },
    methods: { 
        async init() {
        },
    },
    components: {
    }
}
</script>

<style scoped>
.container {
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
}
@media (min-width: 768px) {
    .container {
        width: 750px;
    }
}
@media (min-width: 992px) {
    .container {
        width: 970px;
    }
}
@media (min-width: 1200px) {
    .container {
        width: 1170px;
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue